// Public OAuth identifiers for the Sandeu DLS Portal Azure AD app
// registration. These are not secrets — they ship in the client bundle and
// appear in OAuth URLs during login. Hardcoded as fallbacks so previews and
// new environments work without depending on per-environment build vars in
// Cloudflare Pages. Env vars still override when present.
const DEFAULT_CLIENT_ID = "9784525e-63cf-4892-bae9-977cbc0d4d44";
const DEFAULT_TENANT_ID = "6b55daa3-cebd-46b3-9968-f07239903951";

const clientId = process.env.REACT_APP_CLIENT_ID || DEFAULT_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID || DEFAULT_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId: clientId || "",
    authority: `https://login.microsoftonline.com/${tenantId || ""}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Sites.Read.All", "Sites.ReadWrite.All"],
};

export const graphScopes = {
  scopes: ["Sites.ReadWrite.All"],
};

export function getUserRole(account) {
  const upn = (account?.username || "").toLowerCase();
  if (upn === "carl@sandeu.au") {
    return "admin";
  }
  if (upn.endsWith("@sandeu.au")) {
    return "standard";
  }
  return "standard";
}
